import request from '@/utils/request'
import { sift_query_list } from '@/utils/sift';

/* *******************队列管理************************ */
// 获取列表
export function getImQueueManageLists(data) {
	return request({
	    url: `/livechat/queueManager/list`,
	    method: 'post',
		data: data
	})
}

/* *******************坐席监控************************ */
// 获取列表
export function getImImMonitorLists(query) {
    return request({
        url: `/livechat/agent/manager/list`,
        method: 'get',
		params: sift_query_list(query)
    })
}
// 接线量详情
export function getImImMonitorListsNum(userId,query) {
    return request({
        url: `/livechat/agent/manager/get/chatting/list/${userId}`,
        method: 'get',
		params: sift_query_list(query)
    })
}



/* *******************留言管理************************ */
// 获取列表
export function getImLeaveMessageLists(data) {
    return request({
        url: `/livechat/leavemsg/list`,
        method: 'post',
		data: data
    })
}
// 废弃某条记录
export function deleteImLeaveMessageListsItem(data) {
    return request({
        url: `/livechat/leavemsg/discard`,
        method: 'post',
		data: data
    })
}
//上传文件
export function uploadImLeaveMessageFile(data) {
	return request({
	    url: `/ocs-kdb/manager/file/upload`,
	    method: 'post',
		data: data
	})
}
//回复留言
export function receveImLeaveMessageItem(data) {
	return request({
	    url: `/livechat/leavemsg/response/msg`,
	    method: 'post',
		data: data
	})
}

/* *******************服务窗口************************ */
//渠道查询
export function getIMChannelList(){
	return request({
	    url: `/livechat/report/option/list/channel`,
	    method: 'get',
	})
}
//上传文件
export function uploadImServiceFile(url,data) {
	return request({
	    url: url,
	    method: 'post',
		data: data
	})
}
// 获取对话中人员列表
export function getImServiceDialogueLists(agentId) {
    return request({
        url: `/livechat/session/list/chatting/${agentId}`,
        method: 'get',
    })
}
// 获取已结束人员列表
export function getImServiceEndedLists(agentId,query) {
    return request({
        url: `/livechat/session/list/chatted/${agentId}`,
        method: 'get',
		params: sift_query_list(query)
    })
}
//获取转接技能组列表
export function getImServiceTransformLists(brand,query) {
    return request({
        url: `/livechat/online/list/${brand}/skillGroup`,
        method: 'get',
		params: sift_query_list(query)
    })
}
// 转接技能组
export function transformImServiceToSkillGroup(url) {
    return request({
        url: url,
        method: 'get'
    })
}
// 转接指定客服
export function transformImServiceToSkillGroupItem(url) {
    return request({
        url: url,
        method: 'get'
    })
}
// 接受客服转接
export function acceptTransformImService(item,agentId){
	return request({
	    url: `/livechat/forward/accept/${item.session_id}/${item.from}/${agentId}/${item.toBrand}/${item.toSkillGroup}`,
	    method: 'post',
	})
}
// 拒绝客服转接
export function refusedTransformImService(item,agentId){
	return request({
	    url: `/livechat/forward/refused/${item.session_id}/${item.from}/${agentId}/${item.toBrand}/${item.toSkillGroup}`,
	    method: 'post',
	})
}


//获取转接技能组下客服列表
export function getImServiceTransformListsItem(skillGroup,query) {
    return request({
        url: `/livechat/online/list/${skillGroup}/user`,
        method: 'get',
		params: sift_query_list(query)
    })
}
// 结束当前会话
export function toEndImServiceDialogue(session_id) {
	return request({
	    url: `/livechat/session/close/${session_id}`,
	    method: 'post',
	})
}
//判断当前会话是否保存过沟通小结
export function judgeImserviceToSaveCommunication(session_id){
	return request({
		url: `/livechat/session/isSaveIncident/${session_id}`,
		method: 'get',
	})
}
//判断是否展示历史记录按钮【二次进线才会展示】
export function judgeImserviceToShowHistoryBtn(session_id){
	return request({
		url: `/livechat/session/isSecondVisit/${session_id}`,
		method: 'get'
	})
}

// 发送消息
export function toSendImServiceDialogue(data) {
	return request({
	    url: `/livechat/msg/send`,
	    method: 'post',
		data:data
	})
}
//获取已结束聊天详情
export function getImServiceEndedChat(query) {
    return request({
        url: `/livechat/msg/list`,
        method: 'get',
		params: sift_query_list(query)
    })
}
//快捷搜索快捷话术
export function searchImServiceSpeech(url,data) {
    return request({
        url: url,
        method: 'post',
		data: data
    })
}
// 聊天历史
export function getImHistoryLists(url,query){
	return request({
	    url: url,
	    method: 'get',
		params: sift_query_list(query)
	})
}
// 获取对话中列表
export function getImDialogueLists(session_id){
	return request({
	    url: `/livechat/session/get/${session_id}`,
	    method: 'get',
	})
}


/* **********************IM坐席状态********************************* */
// 坐席状态列表
export function getImServiceStatus(brandId){
	return request({
	    url: `/livechat/agent/status/${brandId}/list`,
	    method: 'get',
	})
}
//设置当前坐席状态
export function setImServiceStatus(brandId,id) {
    return request({
        url: `/livechat/agent/status/${brandId}/set?status=${id}`,
        method: 'post',
    })
}
// 当前坐席状态
export function getCurrentImServiceStatus(brandId,query){
	return request({
	    url: `/livechat/agent/status/${brandId}/get`,
	    method: 'get',
		params:sift_query_list(query)
	})
}

/* **********************IM socket********************************* */
// 获取socketToken
export function getImServiceSocketToken(userId,query){
	return request({
	    url: `/websocket-web/getToken/${userId}?grantType=client_credential&secret=granttoken`,
	    method: 'get',
		params:sift_query_list(query)
	})
}

/* **********************人员管理im权限********************************* */
//权限列表
export function getImRoleLists(data){
	return request({
	    url: `/livechat/agent/manager/get/${data.brandIdentify}/${data.userId}`,
	    method: 'get',
	})
}
// 保存权限
export function saveImRoleLists(brandIdentify,data){
	return request({
	    url: `/livechat/agent/manager/update/${brandIdentify}`,
	    method: 'post',
		data:data
	})
}




// 列表查询get
export function get_data(url,query){
    return request({
        url: url,
        method: 'get',
        params: sift_query_list(query)
    })
}
// 列表查询post
export function post_data(url,data){
    return request({
        url: url,
        method: 'post',
        data: data
    })
}